<template>
  <div :class="`${!customClass ? 'custom-overlay' : ''} ${noScroll || isRemoveScroll ? 'no-loading-scroll' : ''}`" v-show="loading || isShow">
    <b-spinner 
      :variant="`${!customClass ? 'light' : ''}`"
      :class="`mx-auto ${!customClass ? 'custom-overlay-spin' : customClass}`"
      style="z-index: 999; align-items: center; display:flex;"
    >
      <div class="text-caption text-muted" v-if="title">{{ title }}</div>
    </b-spinner>
  </div>
</template>

<script>

export default {
  props: {
    loading: Boolean,
    title: String,
    customClass: String,
    noScroll: Boolean
  },
  data() {
    return {
      isShow: false,
      isRemoveScroll: false
    }
  },
  methods: {
    start(isRemoveScroll = false) {
      this.isShow = true
      
      if(isRemoveScroll) 
        this.isRemoveScroll = true
    },
    stop() {
      this.isShow = false
      this.isRemoveScroll = false
    }
  }
}
</script>
<style lang="scss">
.custom-overlay-spin {
  position: fixed; /* Sit on top of the page content */
  display: flex;
  top: 50%;
  left: 0;
  right: 0;
  bottom: 0;
  outline: 0;
  z-index: 9999;
  transform: none; 
  width: 5rem; 
  height: 5rem;
}</style>